import { render, staticRenderFns } from "./coFlowingWater.vue?vue&type=template&id=80e0f72e&scoped=true&"
import script from "./coFlowingWater.vue?vue&type=script&lang=js&"
export * from "./coFlowingWater.vue?vue&type=script&lang=js&"
import style0 from "./coFlowingWater.vue?vue&type=style&index=0&id=80e0f72e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e0f72e",
  null
  
)

export default component.exports